import { render, staticRenderFns } from "./OrganizationDashboardAnalytics.vue?vue&type=template&id=1db2e6e2&scoped=true&"
import script from "./OrganizationDashboardAnalytics.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboardAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboardAnalytics.vue?vue&type=style&index=0&id=1db2e6e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2e6e2",
  null
  
)

export default component.exports